import { Button } from 'components/ui/button';
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyTitle } from 'components/ui/empty';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../services/RouteService';

export default function NotFoundPage() {
  // Hooks
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onClick = () => {
    navigate(routes.home.route);
  };

  return (
    <div className="flex h-full min-h-dvh flex-col bg-background">
      <div className="flex flex-1 items-center justify-center">
        <Empty>
          <EmptyHeader>
            <EmptyTitle>404</EmptyTitle>
            <EmptyTitle>{t(`global.errors.${404}.title`)}</EmptyTitle>
            <EmptyDescription>{t(`global.errors.${404}.message`)}</EmptyDescription>
          </EmptyHeader>
          <EmptyContent>
            <Button onClick={onClick}>{t('menu.home')}</Button>
          </EmptyContent>
        </Empty>
      </div>
    </div>
  );
}
